/**
 * Capira AI Coach — assets/capira-ai-coach.js
 * Scroll reveal · Conversation switcher · Parallax · Counter animation
 */
(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('[data-cac-reveal]');
    if (!els.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-cac-delay') || '0', 10);
        setTimeout(function () { el.classList.add('is-visible'); }, delay);
        observer.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { observer.observe(el); });
  }

  function initConversation() {
    var chips   = document.querySelectorAll('.cac-prompt-chip');
    var replies = document.querySelectorAll('.cac-convo__response');
    if (!chips.length || !replies.length) return;
    function activate(idx) {
      chips.forEach(function (c, i) {
        c.classList.toggle('is-active', i === idx);
        c.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });
      replies.forEach(function (r, i) { r.classList.toggle('is-active', i === idx); });
    }
    chips.forEach(function (chip, idx) {
      chip.addEventListener('click', function () { activate(idx); });
      chip.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(idx); }
      });
      chip.setAttribute('role', 'tab');
      chip.setAttribute('tabindex', '0');
    });
    activate(0);
  }

  function initParallax() {
    var mockup = document.querySelector('.cac-hero__mockup');
    var bg     = document.querySelector('.cac-hero__bg');
    if (!mockup || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var scrollY = window.scrollY;
        var factor  = Math.min(scrollY / window.innerHeight, 1);
        mockup.style.transform = 'translateY(' + (factor * 40) + 'px)';
        if (bg) bg.style.transform = 'translateY(' + (factor * 20) + 'px)';
        ticking = false;
      });
    }, { passive: true });
  }

  function initCounters() {
    var counters = document.querySelectorAll('[data-cac-counter]');
    if (!counters.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el     = entry.target;
        var target = parseFloat(el.getAttribute('data-cac-counter'));
        var prefix = el.getAttribute('data-cac-prefix') || '';
        var suffix = el.getAttribute('data-cac-suffix') || '';
        var dec    = (target % 1 !== 0) ? 1 : 0;
        var dur    = 1400;
        var start  = performance.now();
        function tick(now) {
          var elapsed  = now - start;
          var progress = Math.min(elapsed / dur, 1);
          var ease     = 1 - Math.pow(1 - progress, 4);
          var val      = (target * ease).toFixed(dec);
          el.textContent = prefix + val + suffix;
          if (progress < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
        observer.unobserve(el);
      });
    }, { threshold: 0.5 });
    counters.forEach(function (el) { observer.observe(el); });
  }

  function initHeroChatLoop() {
    var msgs = document.querySelectorAll('.cac-chat-msg, .cac-chat-insight');
    if (!msgs.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var idx = 0;
    msgs.forEach(function (m) { m.style.opacity = '0'; m.style.transition = 'opacity 0.4s ease'; });
    function reveal() {
      if (idx >= msgs.length) return;
      msgs[idx].style.opacity = '1';
      idx++;
      if (idx < msgs.length) setTimeout(reveal, 700);
    }
    setTimeout(reveal, 800);
  }

  function initDesignMode() {
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function () {
        initReveal(); initConversation();
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initConversation();
    initParallax();
    initCounters();
    initHeroChatLoop();
    initDesignMode();
  });
})();
